import { ONE_TRUST_CONSENT_EVENT_TYPE } from './useOneTrustConsentListener'
import { useEffect } from 'react'

export const useFireOneTrustConsentEvent = (): void => {
  useEffect(() => {
    const consentChangedEvent = new Event(ONE_TRUST_CONSENT_EVENT_TYPE)
    window.dispatchEvent(consentChangedEvent)
  }, [])
}
